import React from 'react';
import { ArrowUpDown, ArrowDown, ArrowUp } from 'lucide-react';

export type SortOption = 'alphabetical' | 'favorite' | 'scarier' | 'cuter' | 'technical' | 'year';

interface SortSelectProps {
  value: SortOption;
  onChange: (value: SortOption) => void;
  reverse: boolean;
  onReverseChange: (reverse: boolean) => void;
}

const options: { value: SortOption; label: string }[] = [
  { value: 'alphabetical', label: 'Alphabetically' },
  { value: 'favorite', label: 'Most Popular' },
  { value: 'scarier', label: 'Scariest' },
  { value: 'cuter', label: 'Cutest' },
  { value: 'technical', label: 'Most Technically Impressive' },
  { value: 'year', label: 'Year' }
];

const SortSelect: React.FC<SortSelectProps> = ({ 
  value, 
  onChange,
  reverse,
  onReverseChange
}) => {
  return (
    <div className="flex items-center gap-2">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as SortOption)}
        className="bg-background border border-gray-800 rounded-lg text-content-primary px-3 py-2 focus:ring-2 focus:ring-brand focus:border-brand transition-colors"
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <button
        onClick={() => onReverseChange(!reverse)}
        className="p-2 bg-background border border-gray-800 rounded-lg text-content-secondary hover:text-brand hover:border-brand transition-colors"
        title={reverse ? 'Sort Descending' : 'Sort Ascending'}
      >
        {reverse ? (
          <ArrowDown className="w-4 h-4" />
        ) : (
          <ArrowUp className="w-4 h-4" />
        )}
      </button>
    </div>
  );
};

export default SortSelect;